import React, { useEffect } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import ExploreCard from "./ExploreCard/ExploreCard";
import { Container, Row } from "react-bootstrap";
import "./Explore.css";
import useGetBrandList from "../../utils/CustomHooks/useBrandList";
// import useGetBrandList from "../../utils/CustomHooks/useBrandList";

const Explore = () => {
  const { brandList, getBrandList } = useGetBrandList();
  useEffect(() => {
    getBrandList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <Header />
      <div className="explore_banner">
        <Container>
          <h1 className="explore_title">Explore</h1>
        </Container>
      </div>
      <div className="explore_card">
        <Container>
          <Row>
            {brandList.map((item, index) => (
              <ExploreCard item={item} key={index} />
            ))}
          </Row>
        </Container>
      </div>
      <Footer />
    </div>
  );
};

export default Explore;
